import { useEffect } from 'react';

export enum CustomEvents {
  BATCH_UPLOAD_COMPLETED_EVENT = 'batch-upload-completed',
  AUTO_ONBOARDING_IMPORT_COMPLETED_EVENT = 'auto-onboarding-import-completed',
}

export const dispatchCustomEvent = (
  eventName: CustomEvents,
  eventOptions: CustomEventInit = {}
): void => {
  window.dispatchEvent(new CustomEvent(eventName, eventOptions));
};

export const useSubscribeCustomEvent = (
  eventName: CustomEvents,
  callback: (event?: Event) => void
) => {
  useEffect(() => {
    window.addEventListener(eventName, callback);

    return () => {
      window.removeEventListener(eventName, callback);
    };
  }, [eventName, callback]);
};
